module.exports = __webpack_public_path__ + "static/media/submarine.126e390c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/submarine.png
// module id = 2559
// module chunks = 0